<script lang="ts" >
import Component from 'vue-class-component'
import AdminList from '@/components/admin/AdminList.vue'
import { AloDbMesureType } from '@/models/alodb/AloDbMesureType'
import { FilterMesureType } from '../../../models/filter/FilterMesureType'
import AdminMesureTypeFilter from '@/components/admin/mesureType/AdminMesureTypeFilter.vue'

@Component({
  name: 'AdminMesureTypeList',
    components: {AdminMesureTypeFilter}
})
export default class AdminMesureTypeList extends AdminList<AloDbMesureType> {
  get itemTypeName() {
    return 'MesureType'
  }

  get items()  {             
    return this.$store.myGetters.mesureTypes.filter(m => 
      (this.filter.search.length == 0 ||  m.searchString!.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1) &&
      (this.filter.umtIds.length == 0 || this.filter.umtIds.indexOf(m.UMT_ID!) > -1)  &&
      (this.filter.mesureUniteIds.length == 0 || this.filter.mesureUniteIds.indexOf(m.MUT_ID!) > -1)     
    )    
  }

  get componentFilterName() {
    return 'AdminMesureTypeFilter'
  }

  get filter() {
    return this.$store.myGetters.adminMesureTypeFilter
  }

  get nbFiltre() {
    return this.filter.umtIds.length + this.filter.mesureUniteIds.length + (this.filter.search.length > 0 ? 1 : 0)
  }

  resetFilter() {
    this.$store.myActions.MESURETYPE_UPDATE_FILTER_ADM(new FilterMesureType())
  }
}
</script>